import { DEFAULT_CURRENCY_CODE } from "constants/general.constants";
import getSymbolFromCurrency from "currency-symbol-map";

export function getCurrencySymbol(currencyCode) {
    if (!currencyCode) return getCurrencySymbol(DEFAULT_CURRENCY_CODE)
    return getSymbolFromCurrency(currencyCode) ?? ""
}